<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout row wrap class="custom-mb">
            <v-flex sm12>
                <v-card>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>Edit User Profile</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <router-link class="link-btn square-btn" :to="{name: 'Roles'}">
                            <v-icon color="black" medium>fa-chevron-left</v-icon>
                        </router-link>
                    </v-toolbar>
                    <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-form v-model="valid" class="ldmx-form">
                            <v-container grid-list-xl fluid>
                                <v-layout row wrap>
                                    <v-flex lg12 md12 xs12>
                                        <v-text-field label="Profile Name *" v-model="form.name" :maxlength="32" v-validate="{required: 'form.name', max: 32, no_special_char:'form.name','restrictedWord':[]}" data-vv-name="name" placeholder="" :error-messages="errors.collect('name')" required>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex lg12 md12 xs12>
                                        <v-textarea label="Description" v-model="form.description" data-vv-name="description" v-validate="{max: 64,'restrictedWord':[]}" placeholder="" :error-messages="errors.collect('description')">
                                        </v-textarea>
                                    </v-flex>
                                    <v-flex lg12 md12 xs12>
                                        <h5 :class="[!permissionChecked ? 'error--text' : '']">Permissions *</h5>
                                        <div class="v-text-field__details" v-if="!permissionChecked">
                                            <div class="v-messages error--text">
                                                <div class="v-messages__wrapper">
                                                    <div class="v-messages__message slide-y-transition-enter-to">Please grant permission to atleast one module.</div>
                                                </div>
                                            </div>
                                        </div>
                                        <v-divider></v-divider><br>
                                        <v-data-table :disable-initial-sort="true" :headers="headers" :search="search" :items="modules" :hide-actions="true" :rows-per-page-items="[{text:'All','value':-1}]" class="elevation-1" item-key="name">
                                            <template slot="headers" slot-scope="props">
                                                <tr>
                                                    <th :class="['text-xs-left column sortable', pagination.descending ? 'desc' : 'asc', pagination.sortBy === 'name' ? 'active' : '']" @click="changeSort('name', true)">
                                                        <v-icon small>arrow_upward</v-icon>
                                                        Module Name
                                                    </th>
                                                    <th :class="['text-xs-left column']">
                                                        <v-checkbox v-model="viewPermissionsAllChecked" label="View" @change="setPermissionAll('view')" color="orange darken- white--text"></v-checkbox>
                                                    </th>
                                                    <th :class="['text-xs-left column']">
                                                        <v-checkbox v-model="allPermissionsAllChecked" label="All Rights" @change="setPermissionAll('all')" color="orange darken- white--text"></v-checkbox>
                                                    </th>
                                                </tr>
                                            </template>
                                            <template slot="items" slot-scope="props">
                                                <td>{{props.item.name}}</td>
                                                <td>
                                                    <v-checkbox :value="checkPermission(props.item.Id, 'view')" @change="setPermission(props.item.Id, 'view')" color="orange darken- white--text"></v-checkbox>
                                                </td>
                                                <td>
                                                    <v-checkbox :value="checkPermission(props.item.Id, 'all')" :disabled="isDisabled(props.item.Id)" @change="setPermission(props.item.Id, 'all') " color="orange darken- white--text"></v-checkbox>
                                                </td>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            <div class="form-btn text-xs-right">
                                <v-btn color="gray white--text" @click="$router.push('/roles/list')"><v-icon color="white">fa-times-circle</v-icon>Cancel</v-btn>
                                <v-btn color="green white--text" @click="submit"> Save </v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import GoogleAds from "@/pages/widgets/GoogleAds";
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
import {
    setTimeout
} from 'timers';
export default {
    $_veeValidate: {
        validator: "new"
    },
    components: {
        breadcrumbs,
        GoogleAds
    },
    data: () => ({
        canLeaveWithoutPrompt: false,
        roleId: null,
        assignedModules: {},
        viewPermissionsAllChecked: false,
        allPermissionsAllChecked: false,
        permissionChecked: true,
        pagination: {
            sortBy: 'name'
        },
        isAdmin: false,
        breadcrumbs: [{
                name: 'Dashboard',
                to: "/dashboard",
                disabled: false
            },
            {
                name: 'Reporting',
                to: "/comingsoon",
                disabled: false
            },
            {
                name: 'User Profiles',
                to: "/roles/list",
                disabled: false
            },
            {
                name: 'Edit User Profile',
                disabled: true
            }
        ],
        search: "",
        valid: true,
        headers: [{
                text: "All Rights",
                value: ""
            },
            {
                text: "View",
                value: ""
            }
        ],
        modules: [],
        form: {
            name: "",
            description: "",
            permissionsGroup: []
        },
        permissions: {},
        tmpPermissions: {},
    }),
    created() {
        this.isAdmin = this.$store.state.user.parentId ? false : true;
    },
    mounted() {
        this.roleId = this.$route.query.id;
        if (!this.roleId) {
            this._showToast("Invalid Role ID or no ID provided", "red");
            this.$router.push("/roles/list");
        } else {
            this.getModules();
            this.$validator.localize("en", this.dictionary);
        }

    },
    beforeRouteLeave(to, from, next) {
        if (to.name === 'Login') {
            next();
        } else {
            if (this.canLeaveWithoutPrompt) {
                return next();
            }
            next(window.confirm('Do you really want to leave? You have unsaved changes!'));
        }
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        checkPermission(id, permissionType) {
            let checked = false;
            if (
                this.permissions[id] &&
                this.permissions[id].permission_name === permissionType
            ) {
                checked = true;
            }
            return checked;
        },
        isDisabled(id) {
            let disabled = false;
            if (this.assignedModules[id] === "view" && !this.isAdmin) {
                disabled = true;
            }
            return disabled;
        },
        setPermissionAll(type) {
            let checkStatus;
            if (type == 'view') {
                checkStatus = this.viewPermissionsAllChecked
                if (checkStatus) {
                    this.allPermissionsAllChecked = false
                }
            } else if (type == 'all') {
                checkStatus = this.allPermissionsAllChecked
                if (checkStatus) {
                    this.viewPermissionsAllChecked = false
                }
            }
            const _p = Object.assign({}, this.permissions),
                _tmpP = Object.assign({}, this.tmpPermissions);
            for (var key in _p) {
                if (_p.hasOwnProperty(key)) {
                    this.permissions[key].permission_name = null;
                    if (!this.isAdmin && type === 'all' && _tmpP[key].permission_name === 'view') {
                        continue;
                    }
                    this.permissions[key].permission_name = checkStatus ? type : null;
                }
            }
        },
        setPermission(moduleId, permissionName) {
            const _permissions = Object.assign({}, this.permissions);
            const _pName = _permissions[moduleId].permission_name;
            this.permissions[moduleId].module_id = moduleId.toString();
            this.permissions[moduleId].permission_name = this.permissions[moduleId].permission_name === permissionName ? null : permissionName;
            _pName == 'view' ? this.viewPermissionsAllChecked = false : this.allPermissionsAllChecked = false;
        },
        getModules() {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            if (self.isAdmin) {
                services
                    .get("modules/list")
                    .then(res => {
                        if (res.status === 200) {
                            self._fillPermissionsGroup(res.data.data);
                            self.modules = res.data.data;
                        }
                    })
                    .catch(err => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        self._showToast(err.message, 'red');
                    });
            } else {
                services
                    .get("users/getUserRoles", {
                        Authorization: "Bearer " + self.$store.state.user.token
                    })
                    .then(res => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        let modulesArr = [],
                            tmpModuleIds = {};
                        res.data.data.map(m => {
                            for (let i = 0; i < m.ModulePermissions.length; i++) {
                                const permData = m.ModulePermissions[i];
                                if (!self.assignedModules[permData.module_id] || permData.p_name !== 'view') {
                                    self.assignedModules[permData.module_id] = permData.p_name;
                                }
                                if (!tmpModuleIds[permData.module_id]) {
                                    tmpModuleIds[permData.module_id] = true;
                                    modulesArr.push(permData.Module);
                                }
                            }
                        });
                        self._fillPermissionsGroup(modulesArr);
                        setTimeout(() => {
                            self.modules = modulesArr;
                        }, 50);
                    })
                    .catch(err => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        self._showToast(err.message, 'red')
                    });
            }

        },
        _fillPermissionsGroup(data) {
            const self = this,
                wApp = window.getApp;
            // calling api to fetch saved permissions set
            if (this.$route.query.id) {
                wApp.$emit("showLoader", {
                    show: true
                });
                services
                    .post("roles/roleListById", {
                        id: self.roleId
                    }, {
                        Authorization: "Bearer " + this.$store.state.user.token
                    })
                    .then(res => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        if (res.data.is_error) {
                            self._showToast(res.data.message, 'red');
                            self.canLeaveWithoutPrompt = true;
                            self.$router.push("/roles/list");
                        } else if (res.data.data.Role.created_by === self.$store.state.user.uuid || self.isAdmin) {
                            setTimeout(function () {
                                const modulePerm = {},
                                    roleData = res.data.data.Role,
                                    savedPermCount = {
                                        'view': 0,
                                        'all': 0
                                    };
                                self.form.name = roleData.name;
                                self.form.description = roleData.description;
                                roleData.ModulePermissions.map(p => {
                                    modulePerm[p.module_id] = p;
                                });
                                let tmpPermissions = {};
                                data.map(dt => {
                                    tmpPermissions[dt.Id] = {
                                        module_id: dt.Id.toString(),
                                        permission_name: null
                                    };
                                    if (modulePerm[dt.Id] && modulePerm[dt.Id].p_name) {
                                        const pName = modulePerm[dt.Id].p_name;
                                        tmpPermissions[dt.Id].permission_name = pName;
                                        savedPermCount[pName] = savedPermCount[pName] + 1;
                                    }
                                });
                                if (savedPermCount.view === data.length) {
                                    self.viewPermissionsAllChecked = true;
                                }
                                if (savedPermCount.all === data.length) {
                                    self.allPermissionsAllChecked = true;
                                }
                                self.permissions = tmpPermissions;
                                self.tmpPermissions = tmpPermissions;
                            }, 50);
                        } else {
                            self.canLeaveWithoutPrompt = true;
                            self._showToast("You don't have access to this page", 'red');
                            self.$router.push('/roles/list');
                        }
                    })
                    .catch(err => {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        self._showToast(err.message, 'red');
                    });

            }
        },
        getPermissionsData() {
            let permissionsData = [];
            const _p = this.permissions;
            for (var key in _p) {
                if (_p.hasOwnProperty(key)) {
                    const permObj = this.permissions[key];
                    if (permObj.permission_name !== null) {
                        permissionsData.push(permObj);
                    }
                }
            }
            return permissionsData;
        },
        submit() {
            const self = this,
                wApp = window.getApp;

            this.$validator
                .validateAll()
                .then(isValid => {
                    const permissions = self.getPermissionsData();
                    if (!permissions.length) {
                        self.permissionChecked = false;
                    } else {
                        self.permissionChecked = true;
                    }
                    if (isValid && permissions.length) {
                        const formVal = self.form;
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        services
                            .put(
                                "roles/edit", {
                                    id: self.roleId,
                                    name: formVal.name,
                                    description: formVal.description,
                                    permission: JSON.stringify(permissions)
                                }, {
                                    Authorization: "Bearer " + this.$store.state.user.token
                                }
                            )
                            .then(res => {
                                if (res.status === 200) {
                                    const isErr = res.data.is_error;
                                    self._showToast(res.data.message, isErr ? 'red' : 'green');
                                    wApp.$emit("showLoader", {
                                        show: false
                                    });
                                    if (isErr) {
                                        return;
                                    }
                                    self.canLeaveWithoutPrompt = true;
                                    self.$router.push("/roles/list");
                                }
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.message, 'red');
                            });
                    }
                })
                .catch(err => {});
        },
        clear() {
            this.form = {};
            this.$validator.reset();
        },
        changeSort(column, isSortable) {
            if (!isSortable) {
                return;
            }
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        }
    }
};
</script>

<style lang="stylus" scoped>
.payment-method {
    border: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/pages/roles/Edit.vue